'use client';

import { Box, Stack, Typography } from '@unity/cloud-ui';

export const Frame = (props: { caption?: string; children: React.ReactNode }) => {
  return (
    <Stack
      component="figure"
      p={1}
      borderRadius={2}
      width="100%"
      alignItems="center"
      margin={0}
      border={({ vars }) => `1px solid ${vars.palette.divider} !important`}
      sx={{
        backgroundColor: ({ vars }) => vars.palette.background.paper,
      }}
    >
      {props.children}
      {props.caption ? (
        <Box component="figcaption" paddingX={0.5} paddingBottom={0.5} marginTop={1.5}>
          <Typography align="center">{props.caption}</Typography>
        </Box>
      ) : null}
    </Stack>
  );
};
